// Grouping configuration shared by every metrics view — the list page's table
// and card views and the metric-selection modal — so all three agree on the
// available groupings, the group keys they derive, and the section geometry.

export const METRICS_GROUPING_OPTION = {
  NONE: "none",
  TYPE: "type",
  CATEGORY: "category",
  TAG: "tag",
} as const

export type GroupingOption =
  (typeof METRICS_GROUPING_OPTION)[keyof typeof METRICS_GROUPING_OPTION]

export const METRICS_SORT_OPTION = {
  NAME: "name",
  CREATED: "created",
  UPDATED: "updated",
} as const

export type SortOption =
  (typeof METRICS_SORT_OPTION)[keyof typeof METRICS_SORT_OPTION]

// Accordion group key used for metrics that have no tags when grouping by tag.
export const UNTAGGED_GROUP_KEY = "untagged"

// Derive the accordion group key for a given tag. Must stay in sync with the
// key derivation in MetricsListPage's availableGroupKeys.
export const getTagGroupKey = (tag: string): string => `tag-${tag}`

interface GroupConfig {
  key: GroupingOption
  label: string
  description: string
}

// Extensible grouping configuration
export const GROUPING_OPTIONS: GroupConfig[] = [
  {
    key: METRICS_GROUPING_OPTION.NONE,
    label: "None",
    description: "No grouping - show all metrics in a single list",
  },
  {
    key: METRICS_GROUPING_OPTION.TYPE,
    label: "Type",
    description: "Group by metric type (LLM Binary, LLM Grader, etc.)",
  },
  {
    key: METRICS_GROUPING_OPTION.CATEGORY,
    label: "Category",
    description: "Group by functional category (Conversation Quality, etc.)",
  },
  {
    key: METRICS_GROUPING_OPTION.TAG,
    label: "Tag",
    description: "Group by tag (metrics with multiple tags appear in each)",
  },
]
